var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgImage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    "data-name": "Layer 2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 34.33 24.83",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Add image") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .add-image-cls1 {\n        fill: inherit;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Whiteboard"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "add-image-cls1",
    d: "m29.62,19.72v-4.28l-6.92-3.99-3.37,1.95-7.35-4.24-7.27,4.2v6.37c0,.37.3.68.68.68h23.55c.37,0,.68-.3.68-.68Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "add-image-cls1",
    cx: 22.43,
    cy: 6.74,
    r: 1.95
  }), /*#__PURE__*/React.createElement("path", {
    className: "add-image-cls1",
    d: "m30.85,24.83H3.48c-1.92,0-3.48-1.56-3.48-3.48V3.48C0,1.56,1.56,0,3.48,0h27.37c1.92,0,3.48,1.56,3.48,3.48v17.87c0,1.92-1.56,3.48-3.48,3.48ZM3.48,2.19c-.71,0-1.29.58-1.29,1.29v17.87c0,.71.58,1.29,1.29,1.29h27.37c.71,0,1.29-.58,1.29-1.29V3.48c0-.71-.58-1.29-1.29-1.29H3.48Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImage);
export default __webpack_public_path__ + "static/media/image.9600115d0178d8b9b9e825ce73d82d82.svg";
export { ForwardRef as ReactComponent };